// Decocasa Tasarım Asistanı — marka+seri paket kartları
// Backend: planlayici.decocasa.com.tr/api/tasarim-asistani

(function() {
  const API = window.DA_API
  const S = window.DA_STATE
  const card = document.getElementById('da-card')
  const progress = document.getElementById('da-progress')

  // Üye girişi yapılmamışsa section asistanı hiç render etmiyor (giriş duvarı gösteriliyor).
  // O durumda DA_STATE/#da-card yok; devam etmek konsola "Cannot read properties of
  // undefined (reading 'answers')" hatası basıyordu. Sessizce çık.
  if (!S || !card || !progress) return

  // Kullanıcı kararı: m² sorusu YALNIZCA Seramik'te sorulur. Banyo ve Mutfak akışında
  // kaldırıldı — paket içeriğini bütçe ve renk belirliyor. ("m² büyükse küvet eklensin"
  // kuralı backend'de bütçeye bağlandı.)
  function getSteps() {
    const rt = S.answers.roomType
    if (rt === 'seramik') return ['room', 'area', 'result']
    if (rt === 'banyo') return ['room', 'subarea', 'tone', 'budget', 'result']
    if (rt === 'mutfak') return ['room', 'tone', 'budget', 'result']
    return ['room']
  }

  // ════════ Adım render ════════
  function render() {
    const step = getSteps()[S.step]
    if (step === 'room') return renderRoom()
    if (step === 'subarea') return renderSubarea()
    if (step === 'area') return renderArea()
    if (step === 'tone') return renderTone()
    if (step === 'budget') return renderBudget()
    if (step === 'result') {
      if (S.answers.roomType === 'seramik') return renderSeramik()
      if (S.selectedPackageKey) return renderPackageDetail()
      return renderPackages()
    }
  }

  // İlerleme noktalarını mevcut akışın adım sayısına göre yeniden kurar
  function syncProgressDots() {
    const total = getSteps().length
    if (progress.children.length === total) return
    progress.innerHTML = ''
    for (let i = 0; i < total; i++) {
      const d = document.createElement('div')
      d.className = 'da-progress-step'
      progress.appendChild(d)
    }
  }

  function updateProgress() {
    syncProgressDots()
    const dots = progress.querySelectorAll('.da-progress-step')
    dots.forEach((d, i) => {
      d.classList.remove('active', 'done')
      if (i < S.step) d.classList.add('done')
      else if (i === S.step) d.classList.add('active')
    })
  }

  function next() { S.step++; updateProgress(); render(); window.scrollTo({ top: 0, behavior: 'smooth' }) }
  function back() { S.step--; updateProgress(); render(); window.scrollTo({ top: 0, behavior: 'smooth' }) }

  function navBtns(opts = {}) {
    const { canNext = true, nextLabel = 'İleri', onNext, showBack = true } = opts
    const btns = document.createElement('div')
    btns.className = 'da-buttons'
    if (showBack && S.step > 0) {
      const b = document.createElement('button')
      b.className = 'da-btn'
      b.innerHTML = 'Geri'
      b.onclick = back
      btns.appendChild(b)
    }
    const n = document.createElement('button')
    n.className = 'da-btn da-btn-primary'
    n.innerHTML = nextLabel
    n.disabled = !canNext
    n.onclick = onNext || next
    btns.appendChild(n)
    return btns
  }

  // ════════ Adım 1: Oda Tipi ════════
  function renderRoom() {
    card.innerHTML = ''
    card.appendChild(el('h2', 'da-step-title', 'Hangi mekanı tasarlayalım?'))
    card.appendChild(el('p', 'da-step-subtitle', 'En çok hangi alana ihtiyacın var?'))

    const grid = el('div', 'da-grid da-grid-3')
    ;[
      { id: 'banyo', label: 'Banyo', sub: 'Klozet, lavabo, duş, küvet ve aksesuarlar' },
      { id: 'mutfak', label: 'Mutfak', sub: 'Evye ve batarya' },
      { id: 'seramik', label: 'Seramik Seçimi', sub: 'Metrekareye göre seramik önerisi' },
    ].forEach(opt => {
      const btn = el('button', 'da-option' + (S.answers.roomType === opt.id ? ' selected' : ''))
      btn.innerHTML = `<div class="da-option-label">${opt.label}</div>
        <div class="da-option-sub">${opt.sub}</div>`
      btn.onclick = () => { S.answers.roomType = opt.id; S.answers.banyoAlan = null; render() }
      grid.appendChild(btn)
    })
    card.appendChild(grid)

    card.appendChild(navBtns({ canNext: !!S.answers.roomType }))
  }

  // ════════ Adım 2 (sadece Banyo): Banyo Alanı ════════
  function renderSubarea() {
    card.innerHTML = ''
    card.appendChild(el('h2', 'da-step-title', 'Banyoda hangi alanı tasarlayalım?'))
    card.appendChild(el('p', 'da-step-subtitle', 'Tek bir alana odaklanabilir ya da tüm banyoyu birlikte kurabiliriz.'))

    const grid = el('div', 'da-grid da-grid-3')
    ;[
      { id: 'dus-alani', label: 'Duş Alanı', sub: 'Tepe duşu, el duşu, banyo bataryası' },
      { id: 'lavabo', label: 'Lavabo', sub: 'Lavabo, batarya, sifon' },
      { id: 'klozet', label: 'Klozet', sub: 'Klozet, kapak, gömme rezervuar' },
      { id: 'kuvet', label: 'Küvet', sub: 'Küvet ve küvet bataryası' },
      { id: 'banyo-aksesuari', label: 'Banyo Aksesuarı', sub: 'Ayna, havluluk, askılık ve diğerleri' },
      { id: 'tum-banyo', label: 'Tüm Banyo', sub: 'Banyonun tamamı için komple paket' },
    ].forEach(opt => {
      const btn = el('button', 'da-option' + (S.answers.banyoAlan === opt.id ? ' selected' : ''))
      btn.innerHTML = `<div class="da-option-label">${opt.label}</div>
        <div class="da-option-sub">${opt.sub}</div>`
      btn.onclick = () => { S.answers.banyoAlan = opt.id; render() }
      grid.appendChild(btn)
    })
    card.appendChild(grid)

    card.appendChild(navBtns({ canNext: !!S.answers.banyoAlan }))
  }

  // ════════ Adım: Boyut (m²) ════════
  function renderArea() {
    card.innerHTML = ''
    card.appendChild(el('h2', 'da-step-title', 'Mekanın boyutu?'))
    card.appendChild(el('p', 'da-step-subtitle', 'Yaklaşık metrekareyi seç. Bilmiyor olabilirsin, hazır seçenekler de var.'))

    // Kullanıcı: "seramikte metrekare sınırı olmasın." Slider 3–40 ile sınırlıydı;
    // 200 m²'lik bir zemin girilemiyordu. Slider kolay seçim için duruyor ama asıl
    // giriş serbest sayı alanı — üst sınır yok.
    const sliderBox = el('div', 'da-slider-box')
    sliderBox.innerHTML = `
      <div class="da-slider-value" id="da-area-val">${S.answers.areaM2} m²</div>
      <input type="range" min="1" max="200" step="1" value="${Math.min(S.answers.areaM2, 200)}" class="da-slider" id="da-area-slider"/>
      <div class="da-slider-labels"><span>1 m²</span><span>200 m²+</span></div>
      <div style="margin-top: 14px; display: flex; align-items: center; gap: 10px; justify-content: center;">
        <label for="da-area-input" style="font-size: 13px; opacity: .75;">veya tam değeri gir:</label>
        <input type="number" id="da-area-input" min="1" step="0.5" value="${S.answers.areaM2}"
               style="width: 110px; padding: 8px 10px; border: 1px solid rgba(0,0,0,.2); border-radius: 4px; font-size: 15px; text-align: center;"/>
        <span style="font-size: 13px; opacity: .75;">m²</span>
      </div>
    `
    card.appendChild(sliderBox)

    const presets = el('div', 'da-presets')
    ;[
      { id: 6,  label: 'Küçük (6 m²)' },
      { id: 10, label: 'Standart (10 m²)' },
      { id: 15, label: 'Orta (15 m²)' },
      { id: 25, label: 'Büyük (25 m²)' },
    ].forEach(p => {
      const b = el('button', 'da-preset' + (S.answers.areaM2 === p.id ? ' selected' : ''))
      b.textContent = p.label
      b.onclick = () => {
        S.answers.areaM2 = p.id
        render()
      }
      presets.appendChild(b)
    })
    card.appendChild(presets)

    const slider = document.getElementById('da-area-slider')
    const val = document.getElementById('da-area-val')
    const sayi = document.getElementById('da-area-input')
    slider.oninput = (e) => {
      S.answers.areaM2 = +e.target.value
      val.textContent = S.answers.areaM2 + ' m²'
      sayi.value = S.answers.areaM2
    }
    sayi.oninput = (e) => {
      const v = parseFloat(e.target.value)
      if (!(v > 0)) return
      S.answers.areaM2 = v
      val.textContent = v + ' m²'
      if (v <= 200) slider.value = v
    }

    card.appendChild(navBtns())
  }

  // ════════ Adım: Renk (Armatür Tonu) ════════
  // Şartname: "orda Krom – Beyaz – Altın – Bronz – Siyah sadece 5 seçenek çıkmalı."
  // Ayrıca: "duş alanında beyaz olabilecek hiçbir ürün yok, o yüzden beyaz renk gelmesin"
  // → liste sabit değil, backend'in availableTones yanıtına göre daraltılıyor.
  const TUM_TONLAR = [
    { id: 'Krom',  label: 'Krom',  swatch: 'linear-gradient(135deg, #c0c0c0, #e8e8e8)' },
    { id: 'Beyaz', label: 'Beyaz', swatch: '#ffffff' },
    { id: 'Altın', label: 'Altın', swatch: 'linear-gradient(135deg, #d4a857, #b8893a)' },
    { id: 'Bronz', label: 'Bronz', swatch: 'linear-gradient(135deg, #a07444, #6f4a2a)' },
    { id: 'Siyah', label: 'Siyah', swatch: '#1a1a1a' },
  ]

  function aktifSubArea() {
    return S.answers.roomType === 'banyo' ? S.answers.banyoAlan : 'mutfak'
  }

  // Seçilen alanda gerçekten paket kurulabilen tonları backend'den öğrenir (alan başına
  // bir kez, sonuç önbelleğe alınır). Hata olursa 5 tonun tamamı gösterilir.
  async function tonlariYukle(subArea) {
    S.tonCache = S.tonCache || {}
    if (S.tonCache[subArea]) return S.tonCache[subArea]
    try {
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'availableTones',
          customerId: window.DA_USER?.id,
          customerEmail: window.DA_USER?.email,
          subArea,
        }),
      })
      const data = await res.json()
      S.tonCache[subArea] = (res.ok && data.tones?.length) ? data.tones : TUM_TONLAR.map(t => t.id)
    } catch (_) {
      S.tonCache[subArea] = TUM_TONLAR.map(t => t.id)
    }
    return S.tonCache[subArea]
  }

  function renderTone() {
    const subArea = aktifSubArea()
    const izinli = S.tonCache?.[subArea]

    card.innerHTML = ''
    card.appendChild(el('h2', 'da-step-title', 'Hangi Renk Tonunu Seçmek İstersiniz?'))
    card.appendChild(el('p', 'da-step-subtitle', 'Armatürler bu tonda olacak. Lavabo, klozet ve küvet gibi ürünler kendi doğal renginde kalır.'))

    // Tonlar henüz bilinmiyorsa yükle, gelince yeniden çiz
    if (!izinli) {
      const yukleniyor = el('div', 'da-loading')
      yukleniyor.innerHTML = '<div class="da-loading-spinner"></div><div class="da-loading-text">Bu alan için uygun tonlar getiriliyor...</div>'
      card.appendChild(yukleniyor)
      tonlariYukle(subArea).then(() => { if (getSteps()[S.step] === 'tone') render() })
      return
    }

    const tones = TUM_TONLAR.filter(t => izinli.includes(t.id))
    // Seçili ton artık bu alanda yoksa seçimi düşür
    if (S.answers.tone && !izinli.includes(S.answers.tone)) S.answers.tone = null

    const grid = el('div')
    grid.style.cssText = 'display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 12px; margin: 8px 0 18px;'
    tones.forEach(t => {
      const selected = S.answers.tone === t.id
      const btn = el('button')
      btn.style.cssText = `display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 16px 10px; border: 2px solid ${selected ? 'var(--da-accent, #374672)' : '#e5e7eb'}; border-radius: 12px; background: ${selected ? '#fafaf7' : '#fff'}; cursor: pointer; transition: all 0.15s;`
      btn.innerHTML = `
        <div style="width: 56px; height: 56px; border-radius: 50%; background: ${t.swatch}; border: 1px solid #d1d5db;"></div>
        <div style="font-size: 13px; font-weight: 600; color: #2A2928; text-align: center; line-height: 1.2;">${t.label}</div>
      `
      btn.onclick = () => {
        S.answers.tone = t.id
        render()
      }
      grid.appendChild(btn)
    })
    card.appendChild(grid)

    if (tones.length < TUM_TONLAR.length) {
      const not = el('p', 'da-step-subtitle')
      not.style.cssText = 'font-size: 12px; color: #6b7280; margin-top: -8px;'
      not.textContent = 'Bu alanda karşılığı olmayan tonlar listelenmiyor.'
      card.appendChild(not)
    }

    card.appendChild(navBtns({ canNext: !!S.answers.tone }))
  }

  // ════════ Adım: Bütçe ════════
  // Kullanıcı kararı: bütçe tavanı alana göre değişir — Tüm Banyo 6M, diğer tüm
  // banyo alanları ve Mutfak 2.5M. (Seramikte bütçe adımı hiç sorulmuyor, sınır yok.)
  // Tek bir 6M slider'ı, tek bir lavabo için 6M bütçe girilmesine izin veriyordu.
  const BUTCE_TAVANI = { 'tum-banyo': 6000000, varsayilan: 2500000 }

  function butceTavani() {
    const alan = S.answers.roomType === 'banyo' ? S.answers.banyoAlan : S.answers.roomType
    return BUTCE_TAVANI[alan] || BUTCE_TAVANI.varsayilan
  }

  function renderBudget() {
    card.innerHTML = ''
    const tavan = butceTavani()
    // Tüm Banyo'da 5M seçip geri dönüp Lavabo'ya geçen müşterinin bütçesi tavanın
    // üstünde kalıyordu; slider görünürde tavana oturuyor ama değer eski kalıyordu.
    if (S.answers.budget > tavan) S.answers.budget = tavan

    card.appendChild(el('h2', 'da-step-title', 'Bütçen ne kadar?'))
    card.appendChild(el('p', 'da-step-subtitle', 'Yaklaşık olarak yaz. Bu rakama en yakın paketleri göstereceğiz.'))

    const tavanEtiket = tavan >= 1000000 ? (tavan / 1000000) + 'M' : Math.round(tavan / 1000) + 'K'
    const sliderBox = el('div', 'da-slider-box')
    sliderBox.innerHTML = `
      <div class="da-slider-value" id="da-budget-val">${fmt(S.answers.budget)} ₺</div>
      <input type="range" min="50000" max="${tavan}" step="25000" value="${S.answers.budget}" class="da-slider" id="da-budget-slider"/>
      <div class="da-slider-labels"><span>50K</span><span>${tavanEtiket}</span></div>
    `
    card.appendChild(sliderBox)

    const presets = el('div', 'da-presets')
    ;(tavan >= 6000000
      ? [
        { id: 500000,  label: '500K · Giriş' },
        { id: 1500000, label: '1.5M · Orta' },
        { id: 3000000, label: '3M · Üst' },
        { id: 4500000, label: '4.5M · Lüks' },
        { id: 6000000, label: '6M · Premium' },
      ]
      : [
        { id: 150000,  label: '150K · Giriş' },
        { id: 400000,  label: '400K · Orta' },
        { id: 900000,  label: '900K · Üst' },
        { id: 1600000, label: '1.6M · Lüks' },
        { id: 2500000, label: '2.5M · Premium' },
      ]
    ).forEach(p => {
      const b = el('button', 'da-preset' + (S.answers.budget === p.id ? ' selected' : ''))
      b.textContent = p.label
      b.onclick = () => { S.answers.budget = p.id; render() }
      presets.appendChild(b)
    })
    card.appendChild(presets)

    const slider = document.getElementById('da-budget-slider')
    const val = document.getElementById('da-budget-val')
    slider.oninput = (e) => {
      S.answers.budget = +e.target.value
      val.textContent = fmt(S.answers.budget) + ' ₺'
    }

    card.appendChild(navBtns({ nextLabel: 'Paketleri Oluştur', onNext: submit }))
  }

  // ════════ Seramik Seçimi — m²'den kutu hesabı ════════
  // Seramikte fiyat KUTU fiyatıdır, m² değil. Backend her serinin `custom.kutu_m2`
  // değerinden gereken kutu adedini hesaplar (%10 fire payı dahil) ve gerçek toplamı
  // döner. Bu yüzden banyo/mutfak "paket" akışından ayrı bir ekran.
  function renderSeramik() {
    if (S.seramikYukleniyor) return
    if (!S.seramik) { loadSeramik(); return }

    card.innerHTML = ''
    const r = S.seramik
    card.appendChild(el('h2', 'da-step-title', 'Seramik Önerileri'))
    card.appendChild(el('p', 'da-step-subtitle',
      `${r.areaM2} m² için uygun seriler — fiyatlar kutu adedine göre hesaplandı.`))

    const bilgi = el('div', 'da-advice')
    bilgi.innerHTML = `Hesaplama <strong>${r.areaM2} m²</strong> + <strong>%${Math.round((r.fire || 0) * 100)} fire payı</strong>
      (kesim ve kırık kaybı) = <strong>${r.hesaplananM2} m²</strong> üzerinden yapıldı.
      Kutu adetleri tam kutuya yuvarlanır; seramik kutu ile satılır.`
    card.appendChild(bilgi)

    if (!r.oneriler?.length) {
      card.appendChild(el('p', 'da-step-subtitle', r.sebep || 'Bu alan için seramik bulunamadı.'))
    } else {
      const liste = el('div', 'da-products')
      liste.style.cssText = 'margin-top: 18px;'
      r.oneriler.forEach(o => {
        const prod = o.product || {}
        const satir = el('div', 'da-product')
        const img = prod.image
          ? `<img src="${prod.image}" alt="${escapeHtml(prod.imageAlt || prod.name || '')}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;"/>`
          : '<div style="height: 100%;"></div>'
        const olcu = prod.boyut ? ` · ${escapeHtml(prod.boyut)}` : ''
        const renkler = o.renkSecenekleri?.length
          ? ` · <span style="color: var(--da-accent, #374672); font-weight: 600;">${o.renkSecenekleri.length} renk seçeneği</span>`
          : ''
        satir.innerHTML = `
          <div class="da-product-img" style="overflow: hidden;">${img}</div>
          <div class="da-product-info">
            <div class="da-product-cat">${escapeHtml(prod.vendor || '')}${olcu}${renkler}</div>
            <div class="da-product-name">${escapeHtml(prod.name || '')}</div>
            <div class="da-product-price">
              <strong>${fmt(o.toplam)} ₺</strong> ·
              ${o.kutuAdedi} kutu × ${fmt(prod.price)} ₺ ·
              ${fmt(o.birimFiyatM2)} ₺/m² · ${o.kapsananM2} m² kapsar
            </div>
          </div>
          <div class="da-product-actions">
            <button class="da-icon-btn" onclick="DA_seramikTeklife('${escapeHtml(o.sku)}')">Teklife Ekle</button>
            <a class="da-icon-btn" href="/products/${prod.handle || ''}" target="_blank" style="text-decoration: none;">İncele</a>
          </div>
        `
        liste.appendChild(satir)
      })
      card.appendChild(liste)
    }

    const btns = document.createElement('div')
    btns.className = 'da-buttons'
    const backBtn = document.createElement('button')
    backBtn.className = 'da-btn'
    backBtn.innerHTML = 'Geri'
    backBtn.onclick = () => { S.seramik = null; back() }
    btns.appendChild(backBtn)
    const restartBtn = document.createElement('button')
    restartBtn.className = 'da-btn da-btn-primary'
    restartBtn.innerHTML = 'Yeniden Başla'
    restartBtn.onclick = () => location.reload()
    btns.appendChild(restartBtn)
    card.appendChild(btns)
  }

  async function loadSeramik() {
    S.seramikYukleniyor = true
    card.innerHTML = `
      <div class="da-loading">
        <div class="da-loading-spinner"></div>
        <div class="da-loading-text">Seramik önerileri hazırlanıyor...</div>
        <div class="da-loading-sub">${S.answers.areaM2} m² için kutu hesabı yapılıyor</div>
      </div>
    `
    try {
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'ceramic',
          customerId: window.DA_USER?.id,
          customerEmail: window.DA_USER?.email,
          areaM2: S.answers.areaM2,
        }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Seramik önerileri hazırlanamadı')
      S.seramik = data
    } catch (err) {
      card.innerHTML = `
        <div class="da-loading">
          <div class="da-loading-text">Bir sorun oldu</div>
          <div class="da-loading-sub">${escapeHtml(err.message)}</div>
          <button class="da-btn da-btn-primary" onclick="location.reload()" style="margin-top: 20px;">Tekrar Dene</button>
        </div>
      `
      S.seramikYukleniyor = false
      return
    }
    S.seramikYukleniyor = false
    render()
  }

  // Seramik satırını teklif listesine ekler. Teklif listesi seramiği kutu/m² ile
  // gösterebiliyor (isCeramic + paketM2 alanları), o yüzden adet = KUTU ADEDİ.
  window.DA_seramikTeklife = function(sku) {
    const o = S.seramik?.oneriler?.find(x => x.sku === sku)
    if (!o) return
    const prod = o.product || {}
    const kurus = Math.round((prod.price || 0) * 100)
    let mevcut = []
    try { mevcut = JSON.parse(localStorage.getItem('quoteList')) || [] } catch (_) { mevcut = [] }
    if (!mevcut.some(ex => ex.sku === sku)) {
      mevcut.push({
        title: prod.name || '',
        sku: sku,
        color: prod.color || '',
        quantity: o.kutuAdedi,
        unitPrice: kurus,
        lineTotal: kurus * o.kutuAdedi,
        isCeramic: true,
        paketM2: String(o.kutuM2),
        vendor: prod.vendor || '',
        size: prod.boyut || '',
        imageUrl: prod.image || '',
      })
    }
    try {
      localStorage.setItem('quoteList', JSON.stringify(mevcut))
    } catch (_) {
      alert('Teklif listesi kaydedilemedi. Tarayıcı depolama izni kapalı olabilir.')
      return
    }
    window.location.href = '/pages/teklif-listem'
  }

  // ════════ Paketleri iste ════════
  async function submit() {
    const subArea = S.answers.roomType === 'banyo' ? S.answers.banyoAlan : 'mutfak'
    S.step++
    updateProgress()
    card.innerHTML = `
      <div class="da-loading">
        <div class="da-loading-spinner"></div>
        <div class="da-loading-text">Paketler hazırlanıyor...</div>
        <div class="da-loading-sub">Decocasa kataloğu taranıyor</div>
      </div>
    `

    try {
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'packages',
          customerId: window.DA_USER?.id,
          customerEmail: window.DA_USER?.email,
          roomType: S.answers.roomType,
          subArea,
          // m² artık yalnız Seramik akışında soruluyor; banyo/mutfakta gönderilmez
          tone: S.answers.tone,
          budget: S.answers.budget,
        }),
      })
      const data = await res.json()
      if (res.status === 429) {
        renderLimitReached(data.error)
        return
      }
      if (!res.ok) throw new Error(data.error || 'Paketler hazırlanamadı')
      S.result = data
      S.selectedPackageKey = null
      render()
    } catch (err) {
      card.innerHTML = `
        <div class="da-loading">
          <div class="da-loading-text">Bir sorun oldu</div>
          <div class="da-loading-sub">${escapeHtml(err.message)}</div>
          <button class="da-btn da-btn-primary" onclick="location.reload()" style="margin-top: 20px;">Tekrar Dene</button>
        </div>
      `
    }
  }

  // ════════ Paket Kartları ════════
  function renderPackages() {
    card.innerHTML = ''
    const r = S.result
    card.appendChild(el('h2', 'da-step-title', 'Size Uygun Paketler'))
    card.appendChild(el('p', 'da-step-subtitle', 'Marka ve seriye göre hazırlanan paketlerden birini incele.'))

    if (!r?.packages?.length) {
      card.appendChild(el('p', 'da-step-subtitle', r?.sebep || 'Bu kriterlere uygun paket bulunamadı. Bütçeyi veya rengi değiştirip tekrar deneyin.'))
    } else {
      // Bütçe tavanı: bu alanda satın alınabilir ürünlerden daha yüksek paket kurulamıyor.
      // Müşteriyi boş bırakmak yerine daha kapsamlı alana yönlendiriyoruz.
      if (r.butceTavaniAsildi && r.butceTavani) {
        const uyari = el('div', 'da-advice')
        const tumBanyoda = aktifSubArea() === 'tum-banyo'
        uyari.innerHTML = `
          <strong>Bütçeniz bu alan için fazla.</strong><br>
          ${escapeHtml(S.answers.roomType === 'banyo' ? 'Seçtiğiniz alanda' : 'Mutfakta')} kurulabilecek en kapsamlı paket
          <strong>${fmt(r.butceTavani)} ₺</strong>. ${tumBanyoda
            ? 'Bütçenizin tamamını kullanmak için mimarımızla görüşebilirsiniz.'
            : 'Bütçenizin tamamını değerlendirmek için <strong>Tüm Banyo</strong> seçeneğini deneyin.'}
        `
        card.appendChild(uyari)
      }

      const grid = el('div', 'da-grid da-grid-3')
      r.packages.forEach(pkg => {
        const btn = el('button', 'da-option')
        // Bütçe uyum rozeti — tema CSS'inde within/over/under sınıfları hazır
        const k = pkg.butceKullanim
        let rozet = ''
        if (typeof k === 'number') {
          const durum = k > 105 ? 'over' : (k < 80 ? 'under' : 'within')
          const metin = durum === 'over' ? 'Bütçenin üstünde' : (durum === 'under' ? 'Bütçenin altında' : 'Bütçenize uygun')
          rozet = `<div class="da-result-budget ${durum}" style="margin-top: 8px; font-size: 11px;">${metin} · %${k}</div>`
        }
        const eksik = pkg.eksikKalemler?.length
          ? `<div style="margin-top: 6px; font-size: 11px; color: #9ca3af;">${pkg.eksikKalemler.length} kalem bu seride yok</div>`
          : ''
        btn.innerHTML = `
          <div class="da-option-label">${escapeHtml(pkg.brand)}</div>
          <div class="da-option-sub">${escapeHtml(pkg.seri)} · ${pkg.items.length} ürün</div>
          <div style="margin-top: 10px; font-weight: 700; font-size: 15px;">${fmt(pkg.total)} ₺</div>
          ${rozet}${eksik}
        `
        btn.onclick = () => { S.selectedPackageKey = pkg.key; render() }
        grid.appendChild(btn)
      })
      card.appendChild(grid)
    }

    const btns = document.createElement('div')
    btns.className = 'da-buttons'
    const backBtn = document.createElement('button')
    backBtn.className = 'da-btn'
    backBtn.innerHTML = 'Geri'
    backBtn.onclick = back
    btns.appendChild(backBtn)
    const restartBtn = document.createElement('button')
    restartBtn.className = 'da-btn da-btn-primary'
    restartBtn.innerHTML = 'Yeniden Başla'
    restartBtn.onclick = () => location.reload()
    btns.appendChild(restartBtn)
    card.appendChild(btns)
  }

  // ════════ Paket Detayı — incele / değiştir / çıkar ════════
  function renderPackageDetail() {
    const pkg = S.result.packages.find(p => p.key === S.selectedPackageKey)
    if (!pkg) { S.selectedPackageKey = null; return renderPackages() }

    card.innerHTML = ''
    const header = el('div', 'da-result-header')
    header.innerHTML = `
      <div style="font-size: 11px; color: var(--da-muted); letter-spacing: 0.15em; text-transform: uppercase; margin-bottom: 8px;">
        ${escapeHtml(pkg.brand)} · ${escapeHtml(pkg.seri)}
      </div>
      <h2 class="da-step-title" style="margin: 0 0 8px;">${pkg.items.length} Ürünlük Paket</h2>
      <div class="da-result-total">${fmt(pkg.total)} ₺</div>
    `
    card.appendChild(header)

    const productsBox = el('div', 'da-products')
    pkg.items.forEach(p => {
      const prod = p.product || {}
      const productEl = el('div', 'da-product')
      productEl.dataset.sku = p.sku
      const imgSrc = prod.image
        ? `<img src="${prod.image}" alt="${escapeHtml(prod.imageAlt || prod.name || '')}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;"/>`
        : `<div style="display: flex; align-items: center; justify-content: center; font-size: 12px; color: #9ca3af; height: 100%;"></div>`
      // Kategori etiketi: ebeveyne bağlı kalemlerde neyin parçası olduğu yazılır
      // (örn. "İÇ SET · BANYO BATARYASI").
      const katEtiket = p.ebeveyn ? `${p.category} · ${p.ebeveyn}` : p.category
      // Seçilen ton gerçekten uygulandı mı, müşteri satırda görebilsin.
      const renkEtiket = prod.color
        ? ` · <span style="color: var(--da-accent, #374672); font-weight: 600;">${escapeHtml(prod.color)}</span>`
        : ''
      // Bazı markalarda tek kapak birden fazla seriye hizmet ediyor (Devon'un "Rose"
      // kapağı hem Blues hem Rose klozete uyuyor). Adı farklı olduğu için müşteri
      // uyumsuz sanmasın diye satırda açıkça yazıyoruz.
      const uyumEtiket = p.uyumNotu
        ? `<div class="da-product-cat" style="color: #15803d; margin-top: 2px;">✓ ${escapeHtml(p.uyumNotu)}</div>`
        : ''
      // Teslim süresi + stok. Kullanıcı: "ürünlerin teslim süreleri de yazsın, stokta
      // varsa stok sayısı." Stok indeksten geliyor (Storefront inventory scope'u kapalı).
      const metaParcalar = []
      if (prod.stok > 0) metaParcalar.push(`<span class="da-stok-var">Stokta · ${prod.stok} adet</span>`)
      if (prod.teslimSuresi) metaParcalar.push(`Teslim: ${escapeHtml(prod.teslimSuresi)}`)
      else if (!(prod.stok > 0)) metaParcalar.push('Teslim süresi için bize danışın')
      if (prod.montaj) metaParcalar.push(escapeHtml(prod.montaj))
      const metaEtiket = metaParcalar.length
        ? `<div class="da-product-meta">${metaParcalar.join('<span style="opacity:.4">|</span>')}</div>`
        : ''
      // Müşterinin kendi seçmesi gereken kalemler için açılır kutu (aşağıda doldurulur)
      const secimKutusu = SECIM_KALEMLERI.has(p.category)
        ? `<div class="da-secim-kutu">
             <label for="da-sel-${escapeHtml(p.sku)}">${escapeHtml(p.category)} seçimi — duvarınıza uygun olanı seçin</label>
             <select id="da-sel-${escapeHtml(p.sku)}" data-kalem="${escapeHtml(p.category)}" data-sku="${escapeHtml(p.sku)}">
               <option value="">Seçenekler yükleniyor…</option>
             </select>
           </div>`
        : ''
      productEl.innerHTML = `
        <div class="da-product-img" style="overflow: hidden;">${imgSrc}</div>
        <div class="da-product-info">
          <div class="da-product-cat">${escapeHtml(katEtiket)}</div>
          <div class="da-product-name">${escapeHtml(prod.name || '')}</div>
          <div class="da-product-price">${fmt(prod.price)} ₺ · ${escapeHtml(prod.vendor || '')}${renkEtiket}</div>
          ${uyumEtiket}
          ${metaEtiket}
          ${secimKutusu}
        </div>
        <div class="da-product-actions">
          <button class="da-icon-btn" title="Değiştir" onclick="DA_swapItem('${p.sku}', '${escapeHtml(p.category)}')">Değiştir</button>
          ${p.kilitli
            ? '<span class="da-icon-btn" title="Bu kalem pakette zorunludur" style="opacity: .55; cursor: default;">Zorunlu</span>'
            : `<button class="da-icon-btn" title="Çıkar" onclick="DA_removeFromPackage('${p.sku}')">Çıkar</button>`}
          <a class="da-icon-btn" title="Ürünü incele" href="/products/${prod.handle || ''}" target="_blank" style="text-decoration: none;">İncele</a>
        </div>
      `
      productsBox.appendChild(productEl)
    })
    card.appendChild(productsBox)
    secimKutularniDoldur(pkg)

    // Bu seride karşılığı olmayan kalemler — yanlış ürün koymak yerine açıkça bildiriliyor
    if (pkg.eksikKalemler?.length) {
      const eksikNot = el('div', 'da-advice')
      eksikNot.style.cssText = 'font-size: 13px;'
      eksikNot.innerHTML = `Bu seride bulunmayan kalemler: <strong>${pkg.eksikKalemler.map(escapeHtml).join(', ')}</strong>.
        Uygun olmayan bir ürünle tamamlamak yerine boş bıraktık — mimarımız alternatif önerebilir.`
      card.appendChild(eksikNot)
    }

    const cta = el('div', 'da-cta')
    cta.innerHTML = `
      <button class="da-cta-primary" onclick="DA_addAllToCart()">Tümünü Sepete Ekle (${fmt(pkg.total)} ₺)</button>
      <div class="da-cta-row">
        <button class="da-cta-secondary" onclick="DA_addToQuoteList()">Teklif Listesine Ekle</button>
        <button class="da-cta-secondary" onclick="DA_showLeadForm()">Mimarımıza Sor</button>
        <button class="da-cta-secondary" onclick="location.reload()">Yeniden Başla</button>
      </div>
    `
    card.appendChild(cta)

    const leadHolder = el('div')
    leadHolder.id = 'da-lead-holder'
    card.appendChild(leadHolder)

    const btns = document.createElement('div')
    btns.className = 'da-buttons'
    const backBtn = document.createElement('button')
    backBtn.className = 'da-btn'
    backBtn.innerHTML = 'Paketlere Dön'
    backBtn.onclick = () => { S.selectedPackageKey = null; render() }
    btns.appendChild(backBtn)
    card.appendChild(btns)
  }

  // ════════ Aksiyonlar (global window.DA_*) ════════
  window.DA_swapItem = async function(sku, category) {
    const pkg = S.result?.packages?.find(p => p.key === S.selectedPackageKey)
    if (!pkg) return
    const itemEl = card.querySelector(`[data-sku="${sku}"]`)
    if (itemEl) itemEl.style.opacity = '0.4'
    try {
      const subArea = S.answers.roomType === 'banyo' ? S.answers.banyoAlan : 'mutfak'
      const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'swapItem',
          customerId: window.DA_USER?.id,
          customerEmail: window.DA_USER?.email,
          subArea,
          category,
          rejectedSku: sku,
          tone: S.answers.tone,
          budget: S.answers.budget,
          roomType: S.answers.roomType,
          // Paketin kalan kalemleri: backend yasak marka çiftlerini (Devon&Devon/Dornbracht
          // ile Geberit/Duravit/Hansgrohe) buna göre eliyor. Gömme sistem istisnası
          // kategori adından anlaşıldığı için kategoriyi de gönderiyoruz.
          paketKalemleri: pkg.items.map(i => ({ category: i.category, vendor: i.product?.vendor })),
        }),
      })
      const data = await res.json()
      if (res.status === 429) {
        if (itemEl) itemEl.style.opacity = '1'
        renderLimitReached(data.error)
        return
      }
      if (!res.ok) throw new Error(data.error || 'Ürün değiştirilemedi')
      const idx = pkg.items.findIndex(p => p.sku === sku)
      if (idx >= 0) pkg.items[idx] = data.item
      pkg.total = pkg.items.reduce((s, p) => s + (p.product?.price || 0), 0)
      renderPackageDetail()
    } catch (err) {
      if (itemEl) itemEl.style.opacity = '1'
      alert(err.message || 'Ürün değiştirilemedi')
    }
  }

  // ════════ Teklif Listesine Ekle ════════
  // Şartname: "Teklif Listesine ekle dediğinde teklif listesi sayfamız açılsın ve bir
  // teklif gönderebilsin." Teklif listesi aynı domainde (/pages/teklif-listem) ve verisini
  // localStorage'daki `quoteList` anahtarından okuyor — planner köprüsüyle aynı format.
  // URL parametresi yerine doğrudan localStorage kullanıyoruz: 20 kalemlik paket URL
  // uzunluk sınırını aşabilir.
  window.DA_addToQuoteList = function() {
    const pkg = S.result?.packages?.find(p => p.key === S.selectedPackageKey)
    if (!pkg?.items?.length) return

    const yeniler = pkg.items.map(p => {
      const prod = p.product || {}
      const kurus = Math.round((prod.price || 0) * 100)
      return {
        title: prod.name || '',
        sku: p.sku || '',
        color: prod.color || '',
        quantity: 1,
        unitPrice: kurus,
        lineTotal: kurus,
        isCeramic: false,
        paketM2: '',
        vendor: prod.vendor || '',
        size: '',
        imageUrl: prod.image || '',
      }
    })

    let mevcut = []
    try { mevcut = JSON.parse(localStorage.getItem('quoteList')) || [] } catch (_) { mevcut = [] }
    yeniler.forEach(item => {
      const varMi = mevcut.some(ex => ex.sku && item.sku && ex.sku === item.sku)
      if (!varMi) mevcut.push(item)
    })
    try {
      localStorage.setItem('quoteList', JSON.stringify(mevcut))
    } catch (_) {
      alert('Teklif listesi kaydedilemedi. Tarayıcı depolama izni kapalı olabilir.')
      return
    }
    window.location.href = '/pages/teklif-listem'
  }

  window.DA_removeFromPackage = function(sku) {
    const pkg = S.result?.packages?.find(p => p.key === S.selectedPackageKey)
    if (!pkg) return
    pkg.items = pkg.items.filter(p => p.sku !== sku)
    pkg.total = pkg.items.reduce((s, p) => s + (p.product?.price || 0), 0)
    renderPackageDetail()
  }

  // ════════ Müşterinin kendi seçtiği kalemler ════════
  // Kullanıcı: "gömme rezervuarı müşteri seçsin, bir kutucuk koy oraya seçsin; seçerken
  // alçıpan mı beton mu ve kaç cm olduğunu da görsün." Gömme sistem duvarın içinde
  // kalıyor; hangisinin uyacağını tesisat belirliyor, biz karar veremiyoruz.
  const SECIM_KALEMLERI = new Set(['Gömme Rezervuar', 'Kumanda Paneli'])
  const secenekOnbellek = {}   // kalem adı → seçenek listesi (aynı kalem iki kez çekilmesin)

  async function secimKutularniDoldur(pkg) {
    const kutular = [...card.querySelectorAll('.da-secim-kutu select')]
    if (!kutular.length) return

    for (const kutu of kutular) {
      const kalem = kutu.dataset.kalem
      try {
        if (!secenekOnbellek[kalem]) {
          const res = await fetch(API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'itemOptions',
              customerId: window.DA_USER?.id,
              customerEmail: window.DA_USER?.email,
              kalem,
              tone: S.answers.tone,
            }),
          })
          const data = await res.json()
          if (!res.ok) throw new Error(data.error || 'Seçenekler alınamadı')
          secenekOnbellek[kalem] = data.secenekler || []
        }
      } catch (_) {
        kutu.innerHTML = '<option value="">Seçenekler yüklenemedi — "Değiştir" ile deneyebilirsiniz</option>'
        continue
      }

      const seciliSku = kutu.dataset.sku
      kutu.innerHTML = secenekOnbellek[kalem].map(o => {
        const pr = o.product || {}
        const bilgi = [
          pr.montaj || '',
          pr.stok > 0 ? `stokta ${pr.stok} adet` : (pr.teslimSuresi ? `teslim ${pr.teslimSuresi}` : ''),
        ].filter(Boolean).join(' · ')
        const etiket = `${pr.vendor} ${pr.name}${bilgi ? ' — ' + bilgi : ''} — ${fmt(pr.price)} ₺`
        return `<option value="${escapeHtml(o.sku)}"${o.sku === seciliSku ? ' selected' : ''}>${escapeHtml(etiket)}</option>`
      }).join('')

      kutu.onchange = (e) => DA_secimUygula(kalem, kutu.dataset.sku, e.target.value)
    }
  }

  window.DA_secimUygula = function(kalem, eskiSku, yeniSku) {
    if (!yeniSku || yeniSku === eskiSku) return
    const pkg = S.result?.packages?.find(p => p.key === S.selectedPackageKey)
    const yeni = secenekOnbellek[kalem]?.find(o => o.sku === yeniSku)
    if (!pkg || !yeni) return
    const i = pkg.items.findIndex(p => p.sku === eskiSku)
    if (i < 0) return
    // Kalem kimliği (category/ebeveyn) korunur, ürün değişir
    pkg.items[i] = { ...pkg.items[i], sku: yeni.sku, product: yeni.product }
    pkg.total = pkg.items.reduce((s, p) => s + (p.product?.price || 0), 0)
    renderPackageDetail()
  }

  window.DA_addAllToCart = async function() {
    const pkg = S.result?.packages?.find(p => p.key === S.selectedPackageKey)
    if (!pkg?.items?.length) return
    const items = pkg.items
      .filter(p => p.product?.variantId)
      .map(p => ({ id: parseInt(p.product.variantId, 10), quantity: 1 }))
    if (!items.length) {
      alert('Bu paket için varyant bilgisi bulunamadı. Lütfen ürünleri tek tek inceleyin.')
      return
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
      if (!res.ok) {
        const txt = await res.text()
        let msg = 'Sepete ekleme başarısız'
        try { const j = JSON.parse(txt); msg = j.description || j.message || msg } catch (_) {}
        throw new Error(msg)
      }
      window.location.href = '/cart'
    } catch (err) {
      alert('Sepete ekleme hatası: ' + err.message)
    }
  }

  // ════════ Limit dolunca lead form ════════
  function renderLimitReached(msg) {
    card.innerHTML = ''
    const wrap = el('div', 'da-result-header')
    wrap.style.textAlign = 'center'
    wrap.innerHTML = `
      <h2 class="da-step-title" style="margin: 0 0 12px;">Mimarımız devraldı</h2>
      <p style="color: var(--da-muted); font-size: 14px; line-height: 1.6; max-width: 480px; margin: 0 auto 20px;">
        ${msg || 'Birkaç farklı paket denediniz. Tam aradığınızı bulmak için mimarımız size özel olarak çalışsın.'}
      </p>
    `
    card.appendChild(wrap)
    const holder = document.createElement('div')
    holder.id = 'da-lead-holder'
    card.appendChild(holder)
    DA_showLeadForm()
  }
  window.DA_renderLimitReached = renderLimitReached

  window.DA_showLeadForm = function() {
    const holder = document.getElementById('da-lead-holder')
    if (holder.innerHTML) return holder.scrollIntoView({ behavior: 'smooth' })
    holder.innerHTML = `
      <div class="da-lead-form">
        <h3 style="font-family: 'Playfair Display', serif; margin: 0 0 6px;">Mimarımız size dönsün</h3>
        <p style="color: var(--da-muted); font-size: 13px; margin: 0 0 16px;">
          Bilgilerinizi bırakın, mimarımız bu paketi inceleyip size detaylı önerilerle dönsün.
        </p>
        <input type="text" id="da-lead-name" placeholder="Ad Soyad" required/>
        <input type="tel" id="da-lead-phone" placeholder="Telefon (örn: 0532 ...)" required/>
        <input type="email" id="da-lead-email" placeholder="E-posta (opsiyonel)"/>
        <button class="da-cta-primary" onclick="DA_submitLead()">Mimara Gönder</button>
      </div>
    `
    holder.scrollIntoView({ behavior: 'smooth' })
  }

  window.DA_submitLead = async function() {
    const name = document.getElementById('da-lead-name').value.trim()
    const phone = document.getElementById('da-lead-phone').value.trim()
    const email = document.getElementById('da-lead-email').value.trim()
    if (!name || !phone) {
      alert('Ad ve telefon zorunlu')
      return
    }
    const pkg = S.result?.packages?.find(p => p.key === S.selectedPackageKey)
    const data = {
      name, phone, email,
      answers: S.answers,
      packet: (pkg?.items || []).map(p => ({ sku: p.sku, name: p.product?.name, price: p.product?.price })),
      total: pkg?.total || 0,
      ts: new Date().toISOString(),
    }
    try {
      await fetch('https://planlayici.decocasa.com.tr/api/tasarim-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      // Gonderim sonrasi tesekkur/24 saat yazisi GOSTERILMIYOR (kullanici istegi 2026-08-19):
      // form alani bosaltilir, boylece ayni talep iki kez gonderilemez.
      document.getElementById('da-lead-holder').innerHTML = ''
    } catch (err) {
      alert('Gönderim hatası, tekrar deneyin')
    }
  }

  // ════════ Helpers ════════
  function el(tag, cls, text) {
    const e = document.createElement(tag)
    if (cls) e.className = cls
    if (text) e.textContent = text
    return e
  }
  function fmt(n) {
    return (n || 0).toLocaleString('tr-TR')
  }
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])
  }

  // Başlat
  render()
})();
